// extracted by mini-css-extract-plugin
export default {"wrapper":"HolidaysCalendar_wrapper__VSeTg","calendar":"HolidaysCalendar_calendar__k1oQP"};